<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-center">
      <nav>
        <ul>
          <li>
            <!-- <router-link :to="{path:'/admin'}">Dashboard</router-link> -->
          </li>
        </ul>
      </nav>
      <!-- <div class="copyright d-flex flex-wrap">
        &copy; Oneshot Productions
      </div> -->
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
